import { Button as AButton } from "@aws-amplify/ui-react";
import {
  BrowserRouter as Router,
  Route,
  NavLink,
  Routes,
} from "react-router-dom";
import FeatureFlags from "../Components/AppConfig/FeatureFlags";
import { Home } from "../Components/Home/Home";
import { Currencies } from "../Components/TMC/Currencies/Currencies";
import { ErrorMessages } from "../Components/ErrorMessages/ErrorMessages";
import { Categories } from "../Components/TMC/Categories/Categories";
import { NewMessage } from "../Components/NewMessage/NewMessage";
import { NewPrivacyPolicy } from "../Components/NewPrivacyPolicy/NewPrivacyPolicy";
import { PrivacyPolicy } from "../Components/PrivacyPolicy/PrivacyPolicy";
import { EditPolicy } from "../Components/EditPolicy/EditPolicy";
import { Messages } from "../Components/Messages/Messages";
import { Message } from "../Components/Message/Message";
import { AutoLogout } from "../Components/AutoLogout/AutoLogout";
import { NewPushNotifiction } from "../Components/NewPushNotification/NewPushNotification";
import { PushNotificationEdit } from "../Components/PushNotificationEdit/PushNotificationEdit";
import { PushNotification } from "../Components/PushNotification/PushNotification";
import { APP_VERSION, DEPLOY_ENVIRONMENT } from "../config";
import Icon from "../Images/PostOfficeLogo";
import { API, graphqlOperation } from "aws-amplify";
import * as queries from "../graphql/mutations";
import { GraphQLResult } from "@aws-amplify/api-graphql";
import { navItems } from "./NavConfig";

import "./styles.css";
import { useState } from "react";

type logoutResponse = { logoutUser: { result: boolean } };
const logout = async () => {
  try {
    const response = (await API.graphql(
      graphqlOperation(queries.logoutUser)
    )) as GraphQLResult<logoutResponse>;

    console.log("logout response: ", response);

    if (response.errors) {
      console.log("logout error: ", response.errors);
      throw new Error("Sorry, something went wrong with logging out.");
    }

    const logoutSuccessful: boolean = response.data.logoutUser.result;
    console.log("Logout successful: ", logoutSuccessful);

    // Handle the successful logout, e.g., clear user session or redirect
    if (logoutSuccessful) {
      // Clear user session or redirect as necessary
      console.log("User logged out successfully.");
    } else {
      console.log("Logout failed.");
    }
  } catch (error) {
    console.error("Error during logout: ", error);
  }
};

const NavigationBar = ({ signOut }) => {
  const [open, setOpen] = useState<Set<number>>(new Set());
  const toggle = (i: number) => {
    setOpen((prev) => {
      const next = new Set(prev);
      next.has(i) ? next.delete(i) : next.add(i);
      return next;
    });
  };

  const clickBtn = (path) => {
    window.location.href = path;
  };

  return (
    <AutoLogout signOut={signOut}>
      <Router>
        <div className="app-shell">
          <header className="header"></header>
          <aside className="sidebar">
            <div className="brand">
              <Icon />
              <div className="badge">{"Travel App Back \nOffice"}</div>
            </div>

            <nav style={{ paddingTop: 10 }}>
              {navItems.map((item, i) => {
                const isOpen = open.has(i);
                const hasChildren = !!item.children?.length;

                const isActive =
                  window.location.pathname === item.path ? true : false;

                return (
                  <div key={item.label} style={{ padding: 15 }}>
                    <AButton
                      type="button"
                      variation="primary"
                      className={` nav-parent nav-link ${isActive && !hasChildren ? "active" : ""}`}
                      onClick={() => {
                        if (!hasChildren) {
                          clickBtn(item.path);
                        } else {
                          toggle(i);
                        }
                      }}
                      aria-expanded={isOpen}
                    >
                      <item.icon
                        color={"#bdb3dc"}
                        size={"25px"}
                        style={{ paddingBottom: 3 }}
                      />
                      <span style={{ fontSize: 15, paddingLeft: 5 }}>
                        {item.label}
                      </span>
                      {hasChildren && (
                        <span style={{ marginLeft: "12px", fontSize: "18px" }}>
                          {isOpen ? "▾" : "▸"}
                        </span>
                      )}
                    </AButton>

                    {isOpen && hasChildren && (
                      <div className="dropdown-children">
                        {item.children!.map((child) => (
                          <NavLink
                            key={child.path}
                            className="nav-sublink"
                            to={child.path}
                          >
                            {child.label}
                          </NavLink>
                        ))}
                      </div>
                    )}
                  </div>
                );
              })}
            </nav>

            <div className="signout-btn-container">
              <AButton
                variation="link"
                style={{ width: "80%" }}
                onClick={async () => {
                  await logout(); // Calls the logout function
                  signOut(); // Calls the signOut function after logout
                }}
              >
                Sign Out
              </AButton>
              <div className="env-text">
                {`v${APP_VERSION} • Environment: ${DEPLOY_ENVIRONMENT}`}
              </div>
            </div>
          </aside>
          <div className="page-container main">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/featureflags" element={<FeatureFlags />} />
              <Route path="/currencies" element={<Currencies />} />
              <Route path="/categories" element={<Categories />} />
              <Route path="/errormessages" element={<ErrorMessages />} />
              <Route path="/messages" element={<Messages />} />
              <Route path="/messages/:id" element={<Message />} />
              <Route path="/new-message" element={<NewMessage />} />
              <Route path="/add-policy" element={<NewPrivacyPolicy />} />
              <Route path="/policy" element={<PrivacyPolicy />} />
              <Route path="/policy/:id" element={<EditPolicy />} />
              <Route
                path="/new-notification"
                element={<NewPushNotifiction />}
              />
              <Route path="/push-notification" element={<PushNotification />} />
              <Route
                path="/push-notification/:id"
                element={<PushNotificationEdit />}
              />
            </Routes>
          </div>
        </div>
      </Router>
    </AutoLogout>
  );
};

export default NavigationBar;
